import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { Separator } from "@babackapp/ui/components/separator";
import useTeamMembers from "@babackapp/private-api-client/client/use-team-members";
import useTranslation from "@babackapp/translations/use-translation";
import AddTeamMemberForm from "./add-team-member-form";
import { TeamInvitationListItem } from "./team-invitation-list-item";
import { TeamMemberListItem } from "./team-member-list-item";

export default function TeamMembersList() {
  const { data: shop } = useCurrentShopSuspense();
  const { data: members } = useTeamMembers(shop.id);
  const invitations = shop.pendingUsers;
  const t = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <span className="text-xs text-muted-foreground  uppercase font-semibold">
        {t("settings.team.addACollaborator")}
      </span>

      <AddTeamMemberForm />

      <Separator className="my-2" />

      <span className="text-xs text-muted-foreground  uppercase font-semibold">
        {t("settings.team.title")}
      </span>

      {members?.map((member) => (
        <TeamMemberListItem key={member.userId} member={member} />
      ))}

      {invitations?.length ? (
        <>
          <Separator className="my-2" />
          <span className="text-xs text-muted-foreground px-2 uppercase font-semibold mt-4">
            {t("settings.team.pendingUser")}
          </span>
        </>
      ) : null}
      {invitations?.map((invitation, index) => (
        <TeamInvitationListItem
          key={index}
          email={invitation.email}
          invitedAt={invitation.invitedAt}
        />
      ))}
    </div>
  );
}
